(function() {
  var qs = window.MidYearSaleUtils.qs;
  var qsa = window.MidYearSaleUtils.qsa;
  var formatMoney = window.MidYearSaleUtils.formatMoney;
  var addItems = window.MidYearSaleUtils.addItems;

  function setProcessing(button) {
    var spinnerColor = button.classList.contains('mys-btn--outline') ? '#0062C4' : '#FFFFFF';
    button.style.width = button.offsetWidth + 'px';
    button.classList.add('is-processing');
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = window.MidYearSaleUtils.processingSpinnerHtml(spinnerColor);
  }

  function clearProcessing(button, html) {
    button.classList.remove('is-processing');
    button.removeAttribute('aria-busy');
    button.innerHTML = html;
    button.style.width = '';
  }

  function prefetchQuickView(handle) {
    if (!handle || !customElements || !customElements.get('quick-view')) return;
    var QuickView = customElements.get('quick-view');
    if (QuickView && typeof QuickView.prefetch === 'function') {
      QuickView.prefetch(handle);
    }
  }

  function initBundleQuickViewPrefetch(root) {
    var prefetched = {};
    function queue(handle) {
      if (!handle || prefetched[handle]) return;
      prefetched[handle] = true;
      prefetchQuickView(handle);
    }

    qsa(root, '.mys-bundle-slot__quickview, .mys-modal-product__quickview').forEach(function(trigger) {
      trigger.addEventListener('pointerenter', function() {
        queue(trigger.dataset.productHandle);
      });
      trigger.addEventListener('focus', function() {
        queue(trigger.dataset.productHandle);
      });
    });

    var run = function() {
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var limit = isMobile ? 18 : 12;
      qsa(root, '.mys-bundle-slot__quickview[data-product-handle]').slice(0, limit).forEach(function(trigger) {
        queue(trigger.dataset.productHandle);
      });
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1200 });
    } else {
      window.setTimeout(run, 300);
    }
  }

  function initBundle(root) {
    var modal = qs(root, '[data-mys-modal]');
    if (!modal) return;

    var sectionRoot = root.closest ? root.closest('[data-mid-year-sale]') : root;
    var moneyFormat = sectionRoot ? sectionRoot.dataset.moneyFormat : '';

    var activeSlot = null;
    var activeCard = null;
    var activeCardId = '';
    var activeCategory = '';
    var activePage = 1;

    function formatBundleMoney(cents) {
      return formatMoney(cents, moneyFormat);
    }

    function cardDiscounts(card) {
      card = card || activeCard;
      var rootEl = card || sectionRoot;
      return {
        two: Number(rootEl ? rootEl.dataset.discountTwo : 20),
        three: Number(rootEl ? rootEl.dataset.discountThree : 35),
        twoLabel: rootEl ? rootEl.dataset.discountTwoLabel : 'Save 20%',
        threeLabel: rootEl ? rootEl.dataset.discountThreeLabel : 'Save 35%'
      };
    }

    function discountForCount(count, card) {
      var d = cardDiscounts(card);
      if (count >= 3) return d.three;
      if (count >= 2) return d.two;
      if (count >= 1 && card && card.dataset.cardBundleMode === 'build_your_own') return d.two;
      return 0;
    }

    function discountLabelForCount(count, card) {
      var d = cardDiscounts(card);
      if (count >= 3) return d.threeLabel;
      if (count >= 2) return d.twoLabel;
      if (count >= 1 && card && card.dataset.cardBundleMode === 'build_your_own') return d.twoLabel;
      return '';
    }

    function modalProducts() {
      return qsa(modal, '[data-mys-modal-product]');
    }

    function isMobileModal() {
      return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    }

    function modalPerPage() {
      return isMobileModal() ? 999 : 10;
    }

    function matchingModalProducts() {
      return modalProducts().filter(function(product) {
        return product.dataset.cardId === activeCardId && product.dataset.category === activeCategory;
      });
    }

    function selectedVariantIds(card) {
      var ids = {};
      if (!card) return ids;
      qsa(card, '[data-mys-bundle-slot]').forEach(function(slot) {
        if (!slot.dataset.variantId) return;
        if (slot.dataset.slotType === 'optional' && !slot.classList.contains('is-selected')) return;
        ids[slot.dataset.variantId] = true;
      });
      return ids;
    }

    function renderModalProducts() {
      var matches = matchingModalProducts();
      var perPage = modalPerPage();
      var pageCount = Math.max(1, Math.ceil(matches.length / perPage));
      var selectedIds = selectedVariantIds(activeCard);
      if (activePage > pageCount) activePage = pageCount;
      var start = (activePage - 1) * perPage;
      var end = start + perPage;

      modalProducts().forEach(function(product) {
        var visible = matches.indexOf(product) >= 0;
        if (visible && !isMobileModal()) {
          var index = matches.indexOf(product);
          visible = index >= start && index < end;
        }
        product.hidden = !visible;
        product.classList.toggle('is-selected', !!selectedIds[product.dataset.variantId]);
      });

      var pagination = qs(modal, '[data-mys-modal-pagination]');
      var pages = qs(modal, '[data-mys-modal-pages]');
      var prev = qs(modal, '[data-mys-modal-prev]');
      var next = qs(modal, '[data-mys-modal-next]');
      if (!pagination || !pages) return;
      pagination.hidden = isMobileModal() || matches.length === 0;
      pages.innerHTML = '';
      for (var i = 1; i <= pageCount; i += 1) {
        var page = document.createElement('button');
        page.type = 'button';
        page.className = 'mys-modal__page';
        page.textContent = String(i);
        page.dataset.mysModalPage = String(i);
        page.classList.toggle('is-active', i === activePage);
        pages.appendChild(page);
      }
      if (prev) prev.disabled = activePage <= 1;
      if (next) next.disabled = activePage >= pageCount;
    }

    function openModal(category, card) {
      activeCardId = card ? (card.dataset.cardId || card.dataset.card || '') : '';
      activeCategory = category || '';
      activePage = 1;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var titleTemplate = modal.dataset.modalTitleTemplate || 'Choose %category%';
      var modalTitle = qs(modal, '[data-mys-modal-title]');
      if (modalTitle) modalTitle.textContent = titleTemplate.replace('%category%', category);
      renderModalProducts();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      activeSlot = null;
      activeCard = null;
      activeCardId = '';
      activeCategory = '';
      activePage = 1;
    }

    function updateBuildSlotUI(slot, selected) {
      slot.classList.toggle('is-selected', selected);
      slot.dataset.empty = selected ? 'false' : 'true';
      var clearButton = qs(slot, '[data-mys-slot-clear]');
      if (clearButton) clearButton.hidden = !selected;
      var addButton = qs(slot, '[data-mys-slot-add]');
      if (addButton) addButton.hidden = selected;
      var img = qs(slot, '[data-mys-slot-img]');
      var quickView = qs(slot, '[data-mys-slot-quickview]');
      var title = qs(slot, '[data-mys-slot-title]');
      var price = qs(slot, '[data-mys-slot-price]');
      var compare = qs(slot, '[data-mys-slot-compare]');
      if (!selected) {
        if (quickView) quickView.dataset.productHandle = '';
        if (img) {
          img.src = slot.dataset.emptyImage || 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22160%22 height=%22160%22%3E%3C/svg%3E';
          img.hidden = !slot.dataset.emptyImage;
        }
        if (title) title.textContent = slot.dataset.emptyTitle || slot.dataset.category || '';
        if (price) price.textContent = '';
        if (compare) compare.textContent = '';
      }
    }

    function initCard(card) {
      var slots = qsa(card, '[data-mys-bundle-slot]');
      var totalEl = qs(card, '[data-mys-bundle-total]');
      var originalEl = qs(card, '[data-mys-bundle-original]');
      var discountEl = qs(card, '[data-mys-bundle-discount]');
      var progressFill = qs(card, '[data-mys-bundle-progress-fill]');
      var addCart = qs(card, '[data-mys-bundle-add]');
      var buyNow = qs(card, '[data-mys-bundle-buy]');
      var milestones = qsa(card, '[data-mys-milestone]');
      var isBuildMode = card.dataset.cardBundleMode === 'build_your_own';
      var processing = false;

      function requiredSlotsReady() {
        return isBuildMode || slots.filter(function(slot) {
          return slot.dataset.slotType === 'fixed';
        }).every(function(slot) {
          return Number(slot.dataset.variantId) > 0;
        });
      }

      function selectedSlots() {
        return slots.filter(function(slot) {
          if (!slot.dataset.variantId) return false;
          if (slot.dataset.slotType === 'optional') {
            return slot.classList.contains('is-selected');
          }
          return true;
        });
      }

      function updateCheckState(slot, selected) {
        slot.classList.toggle('is-selected', selected);
        var check = qs(slot, '[data-mys-slot-check]');
        if (check) check.setAttribute('aria-pressed', String(selected));
        var unlock = qs(slot, '[data-mys-slot-unlock]');
        if (unlock) {
          unlock.textContent = card.dataset.optionalUnlockLabel || '';
        }
      }

      function updateMilestones(count) {
        milestones.forEach(function(milestone) {
          var index = Number(milestone.dataset.mysMilestone || 0);
          milestone.classList.toggle('is-active', index <= count);
        });
        if (progressFill) {
          var progress = slots.length > 0 ? Math.min(count / slots.length, 1) * 100 : 0;
          progressFill.style.width = progress.toFixed(2) + '%';
        }
      }

      function updateTotal() {
        card.dataset.mysProcessing = String(processing);
        var selected = selectedSlots();
        var count = selected.length;
        var original = selected.reduce(function(sum, slot) {
          return sum + Number(slot.dataset.price || 0);
        }, 0);
        var discount = discountForCount(count, card);
        var savings = Math.round(original * discount / 100);
        var finalTotal = original - savings;

        if (totalEl) totalEl.textContent = formatBundleMoney(finalTotal);
        if (originalEl) {
          originalEl.textContent = formatBundleMoney(original);
          originalEl.hidden = !(discount > 0 && original > 0);
        }
        if (discountEl) {
          discountEl.textContent = discountLabelForCount(count, card);
          discountEl.hidden = !(discount > 0 && original > 0);
        }
        if (milestones.length) updateMilestones(count);
        var unavailable = count === 0 || !requiredSlotsReady();
        if (addCart) addCart.disabled = processing || unavailable;
        if (buyNow) buyNow.disabled = processing || unavailable;
      }

      card._mysUpdateBundleTotal = updateTotal;

      qsa(card, '[data-mys-slot-check]').forEach(function(button) {
        button.addEventListener('click', function(event) {
          event.stopPropagation();
          var slot = button.closest('[data-mys-bundle-slot]');
          if (!slot.dataset.variantId || processing) return;
          updateCheckState(slot, !slot.classList.contains('is-selected'));
          updateTotal();
        });
      });

      qsa(card, '[data-mys-bundle-slot][data-optional="true"]').forEach(function(slot) {
        if (slot.dataset.slotType === 'build' || !slot.dataset.variantId) return;
        var cardEl = qs(slot, '.mys-bundle-slot__card');
        if (!cardEl) return;
        cardEl.addEventListener('click', function(event) {
          if (processing) return;
          if (event.target.closest('quick-view')) return;
          if (event.target.closest('[data-mys-slot-check]')) return;
          updateCheckState(slot, !slot.classList.contains('is-selected'));
          updateTotal();
        });
      });

      qsa(card, '[data-mys-bundle-slot][data-slot-type="build"]').forEach(function(slot) {
        function onSlotActivate(event) {
          if (processing) return;
          if (event) event.stopPropagation();
          activeSlot = slot;
          activeCard = card;
          openModal(slot.dataset.category || 'Outdoor Cameras', card);
        }
        var addBtn = qs(slot, '[data-mys-slot-add]');
        if (addBtn) addBtn.addEventListener('click', onSlotActivate);
        var clearBtn = qs(slot, '[data-mys-slot-clear]');
        if (clearBtn) {
          clearBtn.addEventListener('click', function(event) {
            if (processing) return;
            event.stopPropagation();
            delete slot.dataset.variantId;
            delete slot.dataset.price;
            updateBuildSlotUI(slot, false);
            updateTotal();
            if (modal.classList.contains('is-open')) renderModalProducts();
          });
        }
        var cardEl = qs(slot, '.mys-bundle-slot__card');
        if (cardEl) {
          cardEl.addEventListener('click', function(event) {
            var quickView = event.target.closest('quick-view');
            if (quickView && quickView.dataset.productHandle) return;
            if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;
            onSlotActivate(event);
          });
        }
      });

      function addBundle(checkout) {
        if (processing || !requiredSlotsReady()) return;
        var itemMap = {};
        selectedSlots().forEach(function(slot) {
          var id = Number(slot.dataset.variantId);
          if (!id) return;
          if (!itemMap[id]) itemMap[id] = { id: id, quantity: 0 };
          itemMap[id].quantity += 1;
        });
        var items = Object.keys(itemMap).map(function(id) { return itemMap[id]; });
        if (!items.length) return;
        var button = checkout ? buyNow : addCart;
        var oldHtml = button.innerHTML;
        processing = true;
        updateTotal();
        setProcessing(button);
        addItems(items).then(function() {
          if (checkout) {
            window.location.href = '/checkout';
            return;
          }
          clearProcessing(button, oldHtml);
          processing = false;
          updateTotal();
        }).catch(function(error) {
          processing = false;
          clearProcessing(button, oldHtml);
          window.alert(error.message || 'Unable to add bundle.');
          updateTotal();
        });
      }

      if (addCart) addCart.addEventListener('click', function() { addBundle(false); });
      if (buyNow) buyNow.addEventListener('click', function() { addBundle(true); });
      updateTotal();
    }

    qsa(root, '.mys-bundle-card').forEach(initCard);

    modal.addEventListener('click', function(event) {
      if (event.target.matches('[data-mys-modal-close]') || event.target.closest('[data-mys-modal-close]')) {
        closeModal();
        return;
      }
      var pageButton = event.target.closest('[data-mys-modal-page]');
      if (pageButton) {
        activePage = Number(pageButton.dataset.mysModalPage || 1);
        renderModalProducts();
        return;
      }
      if (event.target.closest('[data-mys-modal-prev]')) {
        activePage = Math.max(1, activePage - 1);
        renderModalProducts();
        return;
      }
      if (event.target.closest('[data-mys-modal-next]')) {
        activePage += 1;
        renderModalProducts();
        return;
      }
      var product = event.target.closest('[data-mys-modal-product]');
      if (!product || !activeSlot || !activeCard || activeCard.dataset.mysProcessing === 'true') return;
      if (product.hidden || product.dataset.cardId !== activeCardId) return;
      if (event.target.closest('quick-view')) return;
      if (!event.target.closest('[data-mys-modal-product-add]')) return;

      activeSlot.dataset.variantId = product.dataset.variantId;
      activeSlot.dataset.price = product.dataset.price || '0';
      if (activeSlot.dataset.slotType === 'build' || activeSlot.dataset.optional === 'true') {
        updateBuildSlotUI(activeSlot, true);
      }
      var img = qs(activeSlot, '[data-mys-slot-img]');
      var quickView = qs(activeSlot, '[data-mys-slot-quickview]');
      var title = qs(activeSlot, '[data-mys-slot-title]');
      var price = qs(activeSlot, '[data-mys-slot-price]');
      var compare = qs(activeSlot, '[data-mys-slot-compare]');
      if (quickView) {
        quickView.dataset.productHandle = product.dataset.productHandle || '';
        quickView.setAttribute('aria-label', 'Quick view ' + (product.dataset.title || 'selected product'));
        prefetchQuickView(quickView.dataset.productHandle);
      }
      if (img) {
        img.src = product.dataset.image;
        img.hidden = false;
      }
      if (title) title.textContent = product.dataset.title;
      if (price) price.textContent = product.dataset.priceText;
      if (compare) compare.textContent = product.dataset.compareText || '';

      var card = activeCard;
      closeModal();
      if (card && typeof card._mysUpdateBundleTotal === 'function') {
        card._mysUpdateBundleTotal();
      }
      renderModalProducts();
    });

    window.addEventListener('resize', function() {
      if (modal.classList.contains('is-open')) renderModalProducts();
    });

    initBundleQuickViewPrefetch(root);
  }

  function initStickyCart(root) {
    var sticky = qs(root, '[data-mys-sticky-cart]');
    if (!sticky) return;
    var sectionRoot = sticky.closest ? sticky.closest('[data-mid-year-sticky-cart-section]') || sticky.closest('[data-mid-year-sale]') : root;
    var moneyFormat = sectionRoot ? sectionRoot.dataset.moneyFormat : '';
    var thresholdOne = Number(sticky.dataset.thresholdOne || 19999);
    var thresholdTwo = Number(sticky.dataset.thresholdTwo || 29999);
    var message = qs(sticky, '[data-mys-sticky-message]');
    var current = qs(sticky, '[data-mys-sticky-current]');
    var compare = qs(sticky, '[data-mys-sticky-compare]');
    var checkout = qs(sticky, '[data-mys-sticky-checkout]');
    var viewCart = qs(sticky, '[data-mys-view-cart]');
    var ring = qs(sticky, '[data-mys-sticky-ring]');
    var giftImg = qs(sticky, '[data-mys-sticky-gift-img]');
    var giftOne = sticky.dataset.giftOne || 'Solar Panel';
    var giftTwo = sticky.dataset.giftTwo || 'ZY-E2';
    var giftOneImage = sticky.dataset.giftOneImage || '';
    var giftTwoImage = sticky.dataset.giftTwoImage || '';
    var messageHtml = message ? message.innerHTML : '';
    var placeholder = null;

    if (!sticky.previousElementSibling || !sticky.previousElementSibling.classList.contains('mys-sticky-cart-placeholder')) {
      placeholder = document.createElement('div');
      placeholder.className = 'mys-sticky-cart-placeholder';
      sticky.parentNode.insertBefore(placeholder, sticky);
    } else {
      placeholder = sticky.previousElementSibling;
    }
    sticky.classList.add('is-flow');

    function syncStickyMode() {
      if (!placeholder) return;
      var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      if (!isMobile) {
        placeholder.style.height = '';
        sticky.classList.remove('is-docked');
        return;
      }
      var stickyHeight = sticky.offsetHeight || 128;
      var rect = placeholder.getBoundingClientRect();
      var buffer = 12;
      var isDocked = sticky.classList.contains('is-docked');
      var shouldDock = isDocked
        ? rect.top <= window.innerHeight - stickyHeight + buffer
        : rect.top <= window.innerHeight - stickyHeight - buffer;
      sticky.classList.toggle('is-docked', shouldDock);
      placeholder.style.height = shouldDock ? '0px' : stickyHeight + 'px';
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          var total = Number(cart.total_price || 0);
          var originalTotal = Number(cart.original_total_price || 0);
          if (!originalTotal && cart.items && cart.items.length) {
            originalTotal = cart.items.reduce(function(sum, item) {
              return sum + Number(item.original_line_price || item.line_price || 0);
            }, 0);
          }
          var target = total < thresholdOne ? thresholdOne : thresholdTwo;
          var gift = total < thresholdOne ? giftOne : giftTwo;
          var giftImage = total < thresholdOne ? giftOneImage : giftTwoImage;
          var remaining = Math.max(0, target - total);
          if (message) {
            if (!qs(message, '[data-mys-sticky-remaining]')) message.innerHTML = messageHtml;
            var remainingEl = qs(message, '[data-mys-sticky-remaining]');
            var giftEl = qs(message, '[data-mys-sticky-gift]');
            if (remainingEl) remainingEl.textContent = formatMoney(remaining, moneyFormat);
            if (giftEl) giftEl.textContent = gift;
          }
          if (ring) {
            var progress = target > 0 ? Math.min(total / target, 1) : 0;
            ring.style.setProperty('--mys-progress', (progress * 100).toFixed(2));
          }
          if (giftImg) {
            if (giftImage && giftImg.getAttribute('src') !== giftImage) giftImg.src = giftImage;
            giftImg.alt = gift;
          }
          if (current) current.textContent = formatMoney(total, moneyFormat);
          if (compare) compare.textContent = formatMoney(originalTotal || total, moneyFormat);
        })
        .catch(function() {});
    }

    if (checkout) checkout.addEventListener('click', function() { window.location.href = '/checkout'; });
    if (viewCart) {
      viewCart.addEventListener('click', function() {
        var cartDrawer = document.getElementById('Cart-Drawer') || document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }
        window.location.href = '/cart';
      });
    }

    refresh();
    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('mid-year:cart-refresh', refresh);
    document.addEventListener('line-item:change:end', refresh);
    document.addEventListener('cart:updated', refresh);
    syncStickyMode();
    window.addEventListener('scroll', syncStickyMode, { passive: true });
    window.addEventListener('resize', syncStickyMode);
  }

  function boot(root) {
    qsa(root, '[data-mid-year-sale]').forEach(function(section) {
      if (section.dataset.boundBundle === 'true') return;
      section.dataset.boundBundle = 'true';
      initBundle(section);
    });
    qsa(root, '[data-mid-year-sticky-cart-section]').forEach(function(section) {
      if (section.dataset.boundStickyCart === 'true') return;
      section.dataset.boundStickyCart = 'true';
      initStickyCart(section);
    });
  }

  function init() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) boot(section);
  });
})();
